export default function CandidateHeader() {
  var whatsappNos = [{
    phone: "919778595719",
    counsellor_name: "Susmitha"
  }, {
    phone: "918921256881",
    counsellor_name: "Avani"
  }, {
    phone: "917510593767",
    counsellor_name: "Anu Mohan"
  }]

  function openWhatsapp() {
    var selected = whatsappNos[Math.floor(Math.random() * whatsappNos.length)];
    var selected_number = selected.phone;
    var url = "";
    if (window.innerWidth < 520) {
      //Show mobile link
      url = "https://api.whatsapp.com/send/?phone=" + selected_number + "&text&app_absent=0";
    } else {
      //Show Web link
      url = "https://api.whatsapp.com/send/?phone=" + selected_number + "&text&app_absent=0";
    }
    window.open(url, '_blank');
  }
  return (
      <footer className="sticky">
        <div className="container-fluid" style={{ background: "#111d30" }}>
          <div className="row ">
            <div className="col-sm-7 col-12 ">
                <ul className="d-flex justify-content-center justify-content-sm-start m-2 p-0 ps-sm-4" style={{listStyle:"none"}}>
                  <li>
                    <a className="text-decoration-none fs-6 text-white" href="tel:+91 994724433"><i className="fas fa-phone"></i> Contact for any queries +91 9947144333</a>
                  </li>
                </ul>
            </div>
            <div className="col-sm-5 col-12 d-sm-flex justify-content-end" >
                <ul className="d-flex d-inline-flex m-2">
                  <li className="mx-3">
                    <a className="text-white" href= "https://www.facebook.com/aspireacademykochi" target="_blank"><i className="fab fa-facebook-f"></i></a>
                  </li>
                  <li className="mx-3">
                    <a className="text-white" href="https://twitter.com/ASPIREITACADEMY" target="_blank"><i className="fab fa-twitter"></i></a>
                  </li>
                  <li className="mx-3">
                    <a className="text-white" href="https://www.youtube.com/channel/UCQiFW4tGkS9PW8ur1xt_ZBw" target="_blank"><i className="fab fa-youtube"></i></a>
                  </li>
                  <li className="mx-3">
                    <a className="text-white" href="https://www.linkedin.com/company/aspire-it-academy" target="_blank"><i className="fab fa-linkedin-in"></i></a>
                  </li>
                  <li className="mx-3">
                    <a className="text-white" href="https://www.instagram.com/aspire.it.academy.kochi" target="_blank"><i className="fab fa-instagram"></i></a>
                  </li>
                  <li className="mx-3">
                    <a className="text-white" onClick={() => openWhatsapp()} style={{cursor: "pointer"}}><i className="fab fa-whatsapp"></i></a>
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </footer>
  )
}